import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WorkOrderListLayer from "../components/WorkOrderListLayer";
import { Icon } from "@iconify/react";


const WorkOrderPage = () => {
  const [viewMode, setViewMode] = useState("panel");

  const headerActions = (
    <div className="btn-group" role="group">
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'list' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('list')}
      >
        <Icon icon="ic:baseline-table-view" className="icon text-xl line-height-1" /> Table
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'calendar' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('calendar')}
      >
        <Icon icon="ic:baseline-calendar-month" className="icon text-xl line-height-1" /> Calendar
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'panel' ? 'bg-white-300 text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('panel')}
      >
        <Icon icon="ic:baseline-view-sidebar" className="icon text-xl line-height-1" /> Panel
      </button>
    </div>
  );

  return (
    <>
      <MasterLayout pageTitle="Work Orders" headerActions={headerActions}>
        <WorkOrderListLayer viewMode={viewMode} />
      </MasterLayout>
    </>
  );
};

export default WorkOrderPage; 
